module.exports = __webpack_public_path__ + "img/fgyl.faeb60d6.png";